<script setup lang="ts"></script>

<template>
	<div class="animate-pulse rounded-sm bg-n-75"></div>
</template>
